// Printable daily site list.
import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { Spinner, ErrorBox, DateField, StatusChip } from '../ui';
import { todayDarwin, toAus, csvDownload } from '../util';

export default function DayList() {
  const [date, setDate] = useState(todayDarwin());
  const [data, setData] = useState<any | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setData(null);
    api(`/daylist?date=${date}`).then(setData).catch(e => setError(e.message));
  }, [date]);

  if (error) return <ErrorBox error={error} />;

  return (
    <div className="page">
      <div className="page-head no-print">
        <h2>Daily site list</h2>
        <div className="btn-row">
          <div style={{ width: 140 }}><DateField value={date} onChange={v => v && setDate(v)} /></div>
          <button className="btn" onClick={() => window.print()}>Print</button>
          <button className="btn" onClick={() => data && csvDownload(`site-list-${date}.csv`,
            ['Name', 'Company', 'Trade', 'Type', 'Work area', 'Supervisor', 'Status', 'Movement', 'Notes'],
            data.people.map((p: any) => [p.name, p.company, p.trade, p.employment_type, p.work_area, p.supervisor, p.status,
              p.arriving ? 'Arriving' : p.departing ? 'Departing' : '', p.notes]))}>Export CSV</button>
        </div>
      </div>
      <h3>Yulara Staff Accommodation — expected onsite {toAus(date)}</h3>
      {!data ? <Spinner /> : (
        <div className="table-wrap">
          <div className="table-scroll">
            <table>
              <thead>
                <tr><th>#</th><th>Name</th><th>Company</th><th>Trade</th><th>Type</th><th>Work area</th><th>Supervisor</th><th>Status</th><th>Movement</th><th>Notes</th></tr>
              </thead>
              <tbody>
                {data.people.length === 0 && <tr><td colSpan={10} className="muted" style={{ padding: 20 }}>Nobody is scheduled onsite on this date.</td></tr>}
                {data.people.map((p: any, i: number) => (
                  <tr key={p.attendance_id}>
                    <td>{i + 1}</td>
                    <td><strong>{p.name}</strong></td>
                    <td>{p.company}</td>
                    <td>{p.trade}</td>
                    <td>{p.employment_type}</td>
                    <td>{p.work_area}</td>
                    <td>{p.supervisor}</td>
                    <td><StatusChip status={p.status} /></td>
                    <td>{p.arriving ? '→ Arriving' : ''}{p.departing ? '← Departing' : ''}</td>
                    <td>{p.notes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ padding: '8px 12px' }} className="muted">Total: {data.people.length} people</div>
        </div>
      )}
    </div>
  );
}
